import { ModelCategory } from '@paragon/contract-library';
import { humanCase } from '@paragon/utilities';

import { PropertySchema } from './PropertySchema';

interface ModelSchemaDefinition<T> {
  displayName?: string | ((item: T) => string);
  pluralName?: string;
  preSorted?: boolean;

  category: ModelCategory;

  children?: { [childName: string]: GenericModelSchema };

  properties: { [name in keyof T]?: PropertySchema<any> };
}

export interface ModelSchema<T> extends ModelSchemaDefinition<T> {
  type: string;
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
export class ModelSchema<T> {
  load(data: T): T & { type: string } {
    return { ...data, type: this.type };
  }

  constructor(name: string, definition: ModelSchemaDefinition<T>) {
    Object.assign(this, definition);

    this.type = name;
  }

  get pluralDisplayName() {
    if (this.pluralName) {
      return this.pluralName;
    }

    return `${humanCase(this.type)}s`;
  }
}

export class GenericModelSchema extends ModelSchema<any> {}
